import { render } from "./colleagueFinder.vue?vue&type=template&id=40c0900c&scoped=true"
import script from "./colleagueFinder.vue?vue&type=script&lang=js"
export * from "./colleagueFinder.vue?vue&type=script&lang=js"

import "./colleagueFinder.vue?vue&type=style&index=0&id=40c0900c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c0900c"]])

export default __exports__